import React from "react";
import PropTypes from "prop-types";
import { StyleSheet, Text, TouchableOpacity } from "react-native";
import LinearGradient from "react-native-linear-gradient";

const GradientButton = props => {
    const { disabled, title, colors, onPress, style } = props;

    if (disabled) {
        return <Text style={[styles.container, styles.title, style, styles.disabled]}>{title}</Text>;
    } else {

        const containerStyle = { ...styles.container };
        const titleStyle = { ...styles.title };

        for (const key in style) {
            if (key === "color" || key === "fontSize") {
                titleStyle[key] = style[key];
            } else {
                containerStyle[key] = style[key];
            }
        }

        return (
            <TouchableOpacity style={containerStyle} onPress={onPress}>
                <LinearGradient colors={colors} start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} style={styles.background}>
                    <Text style={titleStyle}>{title}</Text>
                </LinearGradient>
            </TouchableOpacity>
        )
    }
}

const styles = StyleSheet.create({
    container: {
        width: "100%",
        height: 60,
        borderRadius: 10,
        overflow: "hidden",
    },
    disabled: {
        backgroundColor: "#dfdfdf",
        color: "#a1a1a1",
    },
    background: {
        justifyContent: 'center',
        alignItems: 'center',
        width: "100%",
        height: "100%"
    },
    title: {
        color: "#fff",
        textAlign: 'center',
        textAlignVertical: "center"
    },
});

GradientButton.propTypes = {
    title: PropTypes.string.isRequired,
    colors: PropTypes.arrayOf(PropTypes.string).isRequired,
    onPress: PropTypes.func,
    disabled: PropTypes.bool,
    style: PropTypes.object,
};

GradientButton.defaultProps = {
    disabled: false,
    style: {}
};

export default GradientButton;
